import { FieldValidator } from "./"

export const validateBin: FieldValidator = value => {
  const BIN_REGEXP = /\d{6}/
  let error = null

  if (!value?.match(BIN_REGEXP) || value?.length !== 6) {
    error = "The BIN should be 6 digits."
  }

  return error
}
